import io from 'socket.io-client';

// Socket.io verbindet sich zur gleichen Domain wie die App (http/https automatisch)
const SOCKET_URL = window.location.origin;

let socket = null;

export function initSocket() {
  if (socket) return socket;

  console.log('Connecting to Socket.io at:', SOCKET_URL);
  socket = io(SOCKET_URL, {
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 5,
    transports: ['websocket', 'polling'],
    auth: {
      token: localStorage.getItem('token'),
    },
  });

  socket.on('connect', () => {
    console.log('WebSocket verbunden');
  });

  socket.on('disconnect', () => {
    console.log('WebSocket getrennt');
  });

  socket.on('connect_error', (error) => {
    console.error('WebSocket Fehler:', error);
  });

  return socket;
}

export function getSocket() {
  if (!socket) {
    initSocket();
  }
  return socket;
}

export function subscribeToBoard(boardId, callbacks) {
  const sock = getSocket();
  
  // Benutzer tritt dem Board-Room bei
  sock.emit('join-board', { boardId });

  // Listen to board updates
  if (callbacks.onTaskCreated) {
    sock.off('task:created');
    sock.on('task:created', callbacks.onTaskCreated);
  }

  if (callbacks.onTaskUpdated) {
    sock.off('task:updated');
    sock.on('task:updated', callbacks.onTaskUpdated);
  }

  if (callbacks.onTaskDeleted) {
    sock.off('task:deleted');
    sock.on('task:deleted', callbacks.onTaskDeleted);
  }

  if (callbacks.onCommentCreated) {
    sock.off('comment:created');
    sock.on('comment:created', callbacks.onCommentCreated);
  }

  if (callbacks.onCommentDeleted) {
    sock.off('comment:deleted');
    sock.on('comment:deleted', callbacks.onCommentDeleted);
  }

  if (callbacks.onCommentUpdated) {
    sock.off('comment:updated');
    sock.on('comment:updated', callbacks.onCommentUpdated);
  }

  if (callbacks.onAttachmentCreated) {
    sock.off('attachment:created');
    sock.on('attachment:created', callbacks.onAttachmentCreated);
  }

  if (callbacks.onAttachmentDeleted) {
    sock.off('attachment:deleted');
    sock.on('attachment:deleted', callbacks.onAttachmentDeleted);
  }
}

export function unsubscribeFromBoard(boardId) {
  const sock = getSocket();
  sock.emit('leave-board', { boardId });
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
